import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "suggestionStatusKey"
})
export class SuggestionStatusKeyPipe implements PipeTransform {
  private readonly listStatusKeys: { [key: string]: string } = {
    NEW: "SUGGESTION_LIST_STATUS_NEW",
    POSTPONE: "SUGGESTION_LIST_STATUS_POSTPONE",
    POSTPONE_EXPIRED: "SUGGESTION_LIST_STATUS_POSTPONE_EXPIRED",
    EXECUTING_TASKS: "SUGGESTION_LIST_STATUS_EXECUTING_TASKS",
    SUGGESTION_TASKS_EXPIRED: "SUGGESTION_LIST_STATUS_SUGGESTION_TASKS_EXPIRED",
    REVIEWING: "SUGGESTION_LIST_STATUS_REVIEWING",
    CANCELLED: "SUGGESTION_LIST_STATUS_CANCELLED",
    IMPLEMENTED: "SUGGESTION_LIST_STATUS_IMPLEMENTED",
    APPROVE_CANCELLED: "SUGGESTION_LIST_STATUS_APPROVE_CANCELLED"
  };

  private readonly taskStatusKeys: { [key: string]: string } = {
    EXECUTING: "SUGGESTION_TASK_STATUS_EXECUTING",
    COMPLETED: "SUGGESTION_TASK_STATUS_COMPLETED",
    DONE: "SUGGESTION_TASK_STATUS_DONE"
  };

  transform(value: string): string {
    if (!value) {
      return "";
    }

    const normalized = value
      .toString()
      .trim()
      .replace(/\s+/g, "_")
      .toUpperCase();

    return this.listStatusKeys[normalized] || this.taskStatusKeys[normalized] || normalized;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/pipes/suggestion-status-key.pipe.ts